import React from "react";

import { Box, Drawer, useTheme } from "@mui/material";

import {
  MINI_DRAWER_WIDTH,
  SIDEBAR_PAPER_TRANSITION,
  SIDEBAR_TRANSITION,
} from "../constants";

import SidebarHeader from "./SidebarHeader";
import SidebarNavigation from "./SidebarNavigation";

const TOPBAR_HEIGHT = 56;

interface SidebarProps {
  open: boolean;
  visible: boolean;
  width: number;
  isMobile: boolean;
  onClose: () => void;
  onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  open,
  visible,
  width,
  isMobile,
  onClose,
  onToggle,
}) => {
  const theme = useTheme();

  if (!visible) return null;

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? open : true}
      onClose={onClose}
      sx={{
        width: open ? width : MINI_DRAWER_WIDTH,
        flexShrink: 0,
        // S9: 200ms ease to match the mockup shell.
        transition: SIDEBAR_TRANSITION,
        "& .MuiDrawer-paper": {
          width: open ? width : MINI_DRAWER_WIDTH,
          boxSizing: "border-box",
          bgcolor: "background.paper",
          borderRight: `1px solid ${theme.palette.divider}`,
          zIndex: 100,
          top: isMobile ? 0 : `${TOPBAR_HEIGHT}px`,
          height: isMobile ? "100%" : `calc(100% - ${TOPBAR_HEIGHT}px)`,
          // S9: width/transform share the 200ms ease timing.
          transition: SIDEBAR_PAPER_TRANSITION,
          overflowX: "hidden",
        },
        // S6: translucent backdrop with blur for the temporary (mobile) drawer.
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
        },
      }}
    >
      <Box
        sx={{
          width: open ? width : MINI_DRAWER_WIDTH,
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          transition: SIDEBAR_TRANSITION,
        }}
      >
        <SidebarHeader
          collapsed={!open}
          onToggle={isMobile ? undefined : onToggle}
        />
        <SidebarNavigation collapsed={!open} />
      </Box>
    </Drawer>
  );
};

export default Sidebar;
